import React from "react";
import { Box, FormHelperText } from "@mui/material";

type TYPE_BoxError = {
    error: any;
    boxProps?: any;
    padding?: any;
    children: any;
};
const BoxError: React.FunctionComponent<TYPE_BoxError> = ({ error, children, boxProps = {}, padding = "6px 12px" }) => {
    return (
        <Box
            padding={padding}
            sx={{ height: "95%" }}
            bgcolor={error ? "rgba(255, 0, 0, .1)" : "transparent"}
            {...boxProps}
        >
            {children}
            {error && (
                // @ts-ignore
                <FormHelperText style={{ color: "red" }}>{error.message}</FormHelperText>
            )}
        </Box>
    );
};

export default BoxError;
